/**
 * Règle du jeu affichée en permanence : la réponse est donnée par la
 * ROTATION de la carte (la réponse choisie se place en haut, au milieu —
 * correction prof 2026-09-01, l'ancien libellé disait « en haut à gauche »).
 */
const RotationHint = () => (
  <p className="px-9 pt-2 pb-1 text-[13px] flex-shrink-0 text-white/50">
    Oriente ta feuille : le coin <b className="text-white">en haut au milieu</b> = ta réponse ↑
  </p>
);

export default RotationHint;
